<template>
    <div class="chart-container">
      <b-card>
        <b-card-header>
          <b-card-title>Quotation Priority Analysis</b-card-title>
        </b-card-header>
  
        <apexcharts
          type="bar"
          height="350"
          :options="chartOptions"
          :series="chartSeries"
        ></apexcharts>
      </b-card>
    </div>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  import {
    BCard,
    BCardTitle,
    BCardHeader,
  } from "bootstrap-vue";
  
  export default {
    name: "QuotationPriorityAnalysis",
    components: {
      apexcharts: VueApexCharts,
      BCard,
      BCardTitle,
      BCardHeader,
    },
    props: {
      data: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    computed: {
      chartSeries() {
        // Transform the data into the required format
        return [{
          name: 'Quotations',
          data: this.data.map(item => item.quotationCount)
        }];
      },
      
      chartOptions() {
        return {
          chart: {
            type: 'bar',
            height: 350,
            stacked: false,
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
              }
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + ' quotations';
            },
            style: {
              fontSize: '12px'
            }
          },
          colors: ['#28a745', '#ffc107', '#dc3545'], // Green for Low, Yellow for Medium, Red for High
          xaxis: {
            categories: ['Low Priority', 'Medium Priority', 'High Priority'],
            title: {
              text: 'Priority Level'
            },
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            title: {
              text: 'Number of Quotations'
            },
            labels: {
              formatter: function(val) {
                return Math.round(val);
              }
            }
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + ' quotations';
              }
            }
          },
          legend: {
            show: false
          },
          title: {
            text: 'Distribution of Quotations by Priority Level',
            floating: true,
            offsetY: 0,
            align: 'center',
            style: {
              fontSize: '14px'
            }
          }
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .chart-container {
    padding: 1rem;
  }
  </style>